import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Icon, { icons } from 'components/_new/ui/Icon/Icon'

import s from './ButtonIcon.scss'


const ButtonIcon = ({ icon, className, iconClassName }) => {
  if (!icons[icon]) {
    console.error(`There is no icon with name "${icon}"`)
  }

  return (
    <div className={cx(s.iconContainer, className)}>
      <Icon className={cx(s.icon, s[icon], iconClassName)} name={icon} />
      <svg height="100%" viewBox="0 0 1 1" />
    </div>
  )
}

ButtonIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
}


export default ButtonIcon
